module.exports = __webpack_public_path__ + "img/178.1f667af6.jpg";